<template>
  <div v-if="!kql.loading" class="home">
    <main class="blocks-container">
      <template v-for="(block, index) in blocks" :key="block.id || index">
        <LayoutBlock v-if="typeof block === 'object'" :block="block" />
      </template>
    </main>
  </div>
</template>

<script setup>
import { computed, watchEffect } from 'vue';
import { useStore } from '../KQL.js';
import ScrollFader from '../components/Effects/ScrollFader.vue';
import Navigation from '../components/Navigation/Navigation.vue';
import LayoutBlock from '../components/LayoutBlock.vue';

const kql = useStore();

// Get blocks from page layout
const blocks = computed(() => {
  return kql.page?.layout || [];
});

// Debug: Watch for page data changes
watchEffect(() => {
  if (kql.page?.layout) {
    console.log('Blocks loaded:', kql.page.layout);
  }
});
</script>

<style lang="scss" scoped>
@import '@/css/breakpoints.css';

.blocks-container {
  // Add top padding to account for fixed navigation
  box-sizing: border-box;
  width: 100%;
  overflow: hidden;
  margin: 0;
  padding: 0;
  padding-top: 16rem;
}

@media (--phone) {
  .blocks-container {
    padding-top: 12rem;
  }
}

.blocks-container:deep(section) {
  margin-bottom: 10rem;
}

@media (--phone) {
  .blocks-container:deep(section) {
    margin-bottom: 4rem;
  }
}
</style>
